"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lmiaStreamTypeValueLabel = void 0;
exports.lmiaStreamTypeValueLabel = [
    {
        value: "GTSFull",
        label: "Global Talent Stream",
    },
    {
        value: "SAWPFull",
        label: "Seasonal Agricultural Worker Program",
    },
    {
        value: "Agri",
        label: "Agricultural Stream",
    },
    {
        value: "PermRes",
        label: "Express Entry (permanent residence)",
    },
    {
        value: "Academs",
        label: "Academics, medical doctors, specialists or registered nurses",
    },
    {
        value: "Wage",
        label: "High or Low - wage positions (including Facilitated process from 24 May 2022)",
    },
    {
        value: "Caregiver",
        label: "In-Home Caregiver",
    },
];
